import Head from 'next/head';
import React, { useMemo } from 'react';

import {
  ContentOpener,
  ContentOpenerContentPage,
  isContentOpener,
  isContentOpenerContentPage,
  Page,
} from '../../../models';

interface Props {
  node: Page;
}

function getData(node: Page) {
  const opener = node.content?.find((n) => {
    if (isContentOpener(n) || isContentOpenerContentPage(n)) {
      return true;
    }

    return false;
  }) as ContentOpener | ContentOpenerContentPage | undefined;

  return {
    category: node.site_search_category?.key,
    description: node.socialMeta?.description,
    overline: opener?.overline?.text,
    image: opener?.media?.url,
  };
}

export const SiteSearchMeta: React.FC<Props> = ({ node }: Props) => {
  const { category, overline, description, image } = useMemo(() => getData(node), [node]);

  return (
    <Head>
      {category && <meta key="x:site_search_category" name="x:site_search_category" content={category} />}
      {overline && <meta key="x:site_search_overline" name="x:site_search_overline" content={overline} />}
      {description && <meta key="x:site_search_description" name="x:site_search_description" content={description} />}
      {image && <meta key="x:site_search_image" name="x:site_search_image" content={image} />}
    </Head>
  );
};
